/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from "react";
import AuthService from '../../../services/login/auth.service';
import history from "../login/history";
import { contieneMayuscula, contieneNumeros } from "../../generico/utils/FormatoInput";
import Titulo from "../../generico/TituloPagina";
import DatosSocio from "../../generico/DatosSocio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane  } from "@fortawesome/free-solid-svg-icons";
import Popup from "react-popup";
import $ from "jquery";


export default class CambiarClave extends Component {

  constructor(props) {
    super(props);

    this.state = {

      usuario: AuthService.getSocio(),
      passTemp: undefined,
      passNew: undefined,
      passDupli: undefined,
    };
  }
  componentDidMount() {


  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopup2 = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Continuar",
            className: "success",
            action: function () {
              AuthService.logout();
              Popup.close();
            },
          },
        ],
      },
    });

  enviar = () => {
    if (this.state.passNew !== this.state.passDupli) {
      Popup.queue(
        this.notifiPopup(
          "Error",
          "Su clave de acceso no ha sido modificada porque las claves ingresadas no coinciden"
        )
      );
      return;
    }
    AuthService.resetPinAcceso(this.state.usuario.numeroCedula, this.state.passNew, this.state.passTemp).then(
      (response) => {

        var jsonData = response.data;
        if (jsonData.codigo === '0') {
          Popup.queue(
            this.notifiPopup2(
              "Info",
              "Su clave de acceso ha sido modificada. Deberá reingresar al sistema."
            )
          );
          setTimeout(() => {
            AuthService.logout();
          }, 7000);

        } else {
          const resMessage = jsonData.mensaje;
          Popup.queue(
            this.notifiPopup(
              "Error",
              resMessage
            )
          );
          return;

        }

      },

    );
  }


  resetPin() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.enviar();
      }
    });
    $("#idFormReset").submit(function (e) {
      e.preventDefault();
      $.validator.addMethod(
        "mayuscula",
        function (value, element) {
          return contieneMayuscula(element.value);

        }
      );
      $.validator.addMethod(
        "numero",
        function (value, element) {
          return contieneNumeros(element.value);

        }
      );
      /*$.validator.addMethod(
        "caracter",
        function (value, element) {
          return contieneCaracterEspecial(element.value);
  
        }
      );*/


    }).validate(
      {
        rules: {
          passTemp: {
            required: true,

          },
          passNew: {
            required: true,
            minlength: 8,
            maxlength: 20,
            mayuscula: { mayuscula: false },
            numero: { numero: false },
            //caracter: { caracter: false },

          },
          passNewDupl: {
            required: true,

          },


        },
        messages: {
          passTemp: {
            required: "Este campo es requerido",

          },
          passNew: {
            required: "Este campo es requerido",
            minlength: "Debe ingresar al menos 8 caracteres",
            maxlength: "Debe ingresar como máximo 20 caracteres",
            mayuscula: "Debe ingresar al menos una letra mayúscula",
            numero: "Debe ingresar al menos un número",
            caracter: "Debe tener al menos un caracter especial",

          },
          passNewDupl: {
            required: "Este campo es requerido",
          },


        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          element.closest(".form-group").append(error);
        },
        highlight: function (element, errorClass, validClass) {
          $(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Cambio de Clave" />
        <section className="content">
          <div className="container">
            <div className="row" >
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-7 col-md-6">
                        <div className="callout callout-warning consideraciones">
                          <h5>Consideraciones</h5>
                          <p className="consider">Recuerde que la Clave es exclusivamente para su uso personal, y que la misma sustituye a su firma, siendo de su entera responsabilidad el uso de la misma. No la divulgue.
                            Tenga presente que la Universitaria Ltda. nunca solicitará vía telefónica o por email datos personales, número de cuenta, número de tarjeta de crédito, contraseñas o cualquier otra información confidencial.
                            Proteja la información de sus cuentas, una vez que haya finalizado sus operaciones, cierre el navegador.</p>
                        </div>
                       
                      </div>
                      <div className="col-lg-5 col-md-6 border-cards">
                        <div className="card-body login-card-body">
                          <form id="idFormReset">

                            <div className="form-group">
                              <label className="input-label-bold">Clave Actual *</label>
                              <input type="password" className="input-box form-control" name="passTemp" defaultValue={this.state.passTemp}
                                onChange={(val) => {
                                  this.setState({ passTemp: val.target.value });
                                }}
                              />
                            </div>
                            <div className="form-group">
                              <label className="input-label-bold">Clave Nueva *</label>
                              <input id="pass" type="password" className="input-box form-control" name="passNew" defaultValue={this.state.passNew}
                                onBlur={(val) => {
                                  this.setState({ passNew: val.target.value });
                                }}

                              />
                            </div>

                            <div className="form-group">
                              <label className="input-label-bold">Confirmar Clave Nueva *</label>
                              <input type="password" className="input-box form-control" name="passNewDupl" defaultValue={this.state.passDupli}
                                onChange={(val) => {
                                  this.setState({ passDupli: val.target.value });
                                }} />
                            </div>
                            <hr />
                            <div className="form-group">
                              <button className="btn btn-cu-primary"  onClick={() => this.resetPin()}>
                               <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                              </button>
                              <a
                                ref={(a) => (this.modalCtrlConfirm = a)}
                                href="#"
                                hidden
                                id="modalCtrlConfirm"
                                data-toggle="modal"
                                data-target="#idModalConfirm"
                              ></a>
                            </div>
                            


                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                              <div className="col-lg-8 col-md-12">
                              <label className="input-label-bold-obligatorio">
                              
                              (*) Campos Obligatorios
                            </label>
                              </div>
                            </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}